// extracted by mini-css-extract-plugin
export default {"section":"_1Z41NLCSKU","header":"_1xorFLfaMb","header-content":"_2DT9rOVoY4","headerContent":"_2DT9rOVoY4","title":"ThxuO3IvUK","description":"_1WXl5b9wdg","expand-button":"Qe7g_pnxXb","expandButton":"Qe7g_pnxXb","content":"_2MJH6QZyQl"};
    if(module.hot) {
      // 1628247838920
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  